import { render, staticRenderFns } from "./ButtonUI.vue?vue&type=template&id=9216b736&scoped=true&"
import script from "./ButtonUI.vue?vue&type=script&lang=js&"
export * from "./ButtonUI.vue?vue&type=script&lang=js&"
import style0 from "./ButtonUI.vue?vue&type=style&index=0&id=9216b736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9216b736",
  null
  
)

export default component.exports